import { Button } from "primereact/button";
import extractDataFromMap from "../../utils/ExtractDataFromMap";
import { format as dateFnsFormat } from "date-fns";

const genTemplateBodyAction = ({ row, onEdit, onDelete }) => {
  return (
    <div className="row-center-center gap-2">
      {onEdit && (
        <Button
          icon="pi pi-pencil"
          rounded
          severity="success"
          className="bg-emerald-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onEdit) onEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onDelete && (
        <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onDelete) onDelete(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
    </div>
  );
};

const genTemplateBodyText = ({ row, field, defaultEmpty }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  return rowDataValue;
};

const genRetribusiTemplateBodyAction = ({
  row,
  onChangeDate,
  onChangeStatus,
  onPayment,
}) => {
  return (
    <div className="row-center-center gap-2">
      {onChangeDate && (
        <Button
          icon="pi pi-calendar"
          rounded
          severity="success"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onChangeDate) onChangeDate(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onChangeStatus && (
        <Button
          icon="pi pi-list-check"
          rounded
          severity="info"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onChangeStatus) onChangeStatus(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
      {onPayment && (
        <Button
          icon="pi pi-dollar"
          rounded
          severity="danger"
          className="max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onPayment) onPayment(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      )}
    </div>
  );
};

const genTemplateBodyNumber = ({
  row,
  field,
  defaultEmpty,
  maxFraction,
  minFraction,
}) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  return rowDataValue
    ? rowDataValue.toLocaleString("id-ID", {
        maximumFractionDigits: maxFraction ?? 2,
        minimumFractionDigits: minFraction ?? 0,
      })
    : defaultEmpty
    ? ""
    : 0;
};

const genTemplateBodyDate = ({ row, field, format }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  if (!rowDataValue) return "";

  const dateObject = new Date(rowDataValue);
  const _format = format ?? "dd/MM/yyyy";

  return dateFnsFormat(dateObject, _format);
};

const genTemplateBodyDateTime = ({ row, field, format }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });

  if (!rowDataValue) return "";

  const dateObject = new Date(rowDataValue);
  const _format = format ?? "dd/MM/yyyy HH:mm";

  return dateFnsFormat(dateObject, _format);
};

const genTemplateBodyImage = ({ row, field }) => {
  const rowDataValue = extractDataFromMap({
    key: field,
    map: row,
  });
  if (rowDataValue && rowDataValue !== null) {
    return (
      <img
        src={`${rowDataValue}`}
        alt={rowDataValue}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  } else {
    return "";
  }
};

export {
  genRetribusiTemplateBodyAction,
  genTemplateBodyAction,
  genTemplateBodyText,
  genTemplateBodyNumber,
  genTemplateBodyDate,
  genTemplateBodyDateTime,
  genTemplateBodyImage,
};
